export default __webpack_public_path__ + "static/americaGalo-fea139a84937ca09129d8cb7998f09de.jpg";